import { notifyError } from "common/utils/app-monitoring/notify";

const $getCSRFToken = () => document.querySelector('[name="csrf-token"]').content;
const $getImageIdsInput = $uploadButton =>
  $uploadButton.parentElement.parentElement.querySelector(".js-image-ids-input");
const $getFileInput = $uploadButton =>
  $uploadButton.parentElement.parentElement.querySelector(".js-file-input");
const $getDiscardButton = $uploadButton =>
  $uploadButton.parentElement.parentElement.querySelector(".js-claim-discard-button");
const $getAllUploadButtons = () => document.querySelectorAll(".js-upload-images-btn");
const $getSubmitClaimRequestButton = () => document.getElementById("js-submit-claim-request");

const setUploadButtonState = ($uploadButton, { text, disabled = false }) => {
  if (text) {
    $uploadButton.textContent = text;
  }
  $uploadButton.disabled = disabled;
};

const setDiscardButtonVisibility = ($discardButton, isVisible) => {
  $discardButton.style.display = isVisible ? "block" : "none";
};

const setImageIds = ($uploadButton, imageIds) => {
  const $hiddenInput = $getImageIdsInput($uploadButton);
  $hiddenInput.value = imageIds.join(",");
};

/* eslint-disable max-lines-per-function */
const handleFileUpload = async (event, $uploadButton) => {
  const $fileInput = event.target;
  const $discardButton = $getDiscardButton($uploadButton);
  const formData = new FormData();

  Array.from($fileInput.files).forEach(file => {
    formData.append("images[]", file);
  });

  try {
    setUploadButtonState($uploadButton, { text: "Uploading...", disabled: true });
    $getSubmitClaimRequestButton().disabled = true;

    const response = await fetch("/orders/claims/upload_images.json", {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": $getCSRFToken()
      }
    });

    if (!response.ok) throw new Error("Upload failed");

    const data = await response.json();
    const currentIds = $getImageIdsInput($uploadButton).value.split(",").filter(Boolean);
    const newIds = currentIds.concat(data.image_ids);

    setImageIds($uploadButton, newIds);

    const imageCount = newIds.length;
    setUploadButtonState($uploadButton, {
      text: `${imageCount} image${imageCount !== 1 ? "s" : ""} uploaded`
    });
    setDiscardButtonVisibility($discardButton, true);

    $fileInput.value = "";
  } catch (error) {
    console.error("Upload error:", error);
    notifyError("Error while uploading supplier admin claim images", {
      params: { error }
    });
    alert("Failed to upload images. Please try again.");
    setUploadButtonState($uploadButton, { text: "Upload Images" });
    setDiscardButtonVisibility($discardButton, false);
  } finally {
    setUploadButtonState($uploadButton, { text: "", disabled: false });
    const $submitButton = $getSubmitClaimRequestButton();
    const isShipmentIneligible = $submitButton.dataset.shipmentIneligible === "true";
    $submitButton.disabled = isShipmentIneligible;
  }
};
/* eslint-enable max-lines-per-function */

const handleDiscardImages = $uploadButton => {
  const $discardButton = $getDiscardButton($uploadButton);
  setImageIds($uploadButton, []);
  setUploadButtonState($uploadButton, { text: "Upload Images" });
  setDiscardButtonVisibility($discardButton, false);
};

const initImageUpload = $uploadButton => {
  const $fileInput = $getFileInput($uploadButton);
  const $discardButton = $getDiscardButton($uploadButton);

  $uploadButton.addEventListener("click", () => $fileInput.click());
  $fileInput.addEventListener("change", event => handleFileUpload(event, $uploadButton));
  $discardButton.addEventListener("click", () => handleDiscardImages($uploadButton));
};

export default () => {
  $getAllUploadButtons().forEach(initImageUpload);
};
